import { required } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core";
import { nextTick } from 'vue'

export default {
    name: 'Login',

    setup() {
        return { v$: useVuelidate() }
    },

    data() {
        return {
            loading: false,
            password: '',
            name: '',
            error: null,
            captcha: {}
        }
    },

    validations: {
        name: { required },
        password: { required }
    },

    computed: {
        isLoggedIn() {
            return !!this.$store.state.token
        }
    },

    methods: {
        async login() {
            this.error = null
            this.v$.$touch()
            if (this.v$.$invalid) return
            this.loading = true
            try {
                const reqData = {
                    username: this.name,
                    password: this.password
                }

                const response = await this.ApiRequest.requestAsync(
                    'login',
                    this.ApiRequest.REQUEST_POST,
                    reqData,
                    'login',
                    false
                )

                if (response.validationErrors) {
                    this.error = response.validationErrors
                    return
                }

                const { token, user } = response.data
                this.$store.commit('setToken', token)
                sessionStorage.setItem('name', user.name)
                sessionStorage.setItem('email', user.email)

                ;(user.user_columns_filter || []).forEach((row) => {
                    if (row.columnVisibility) {
                        localStorage.setItem(`${row.section}-columns`, JSON.stringify(row.columnVisibility))
                    }

                    localStorage.setItem(`${row.section}-page-size`, JSON.stringify(row.page_size))
                })

                await this.$store.dispatch('checkPermission')
                await nextTick()
                await this.$router.push('/billing/balance')
            } catch (error) {
                this.error = error.messageCodes || ['Login failed']
            } finally {
                this.loading = false
            }
        }
    }
}